export const input = css`
  display: block;
  background: var(--light-pink);
  padding: var(--s2);

  &::placeholder {
    color: black;
  }
`

///////////////////////////////////////////////////////////////////////////////////

import { css } from 'styled-components'
